<template>
  <div class="user-set main-panel large">
    <h1 class="panel-title">官方面料信息</h1>
    <div class="content-wrap">
      <!-- 左侧面料表单区域 input输入框 -->
      <div class="left-form">
        <div class="form-item" style="width: 230px; margin-left: 14px">
          <label require>品名编号</label>
          <el-input v-model="formData.productNo" placeholder=""></el-input>
        </div>
        <div class="form-item two-col-wrap">
          <div class="form-item-inline">
            <label>幅宽:</label>
            <el-input type="text" v-model="formData.width"></el-input
            ><span>cm</span>
          </div>
          <div class="form-item-inline">
            <label>克重:</label>
            <el-input type="text" v-model="formData.weight"></el-input
            ><span style="font-size: 15px">g/㎡</span>
          </div>
        </div>
        <div class="form-item" style="width: 230px">
          <label>量化:</label>
          <el-input v-model="formData.quantify"></el-input
          ><span style="font-size: 15px">m/kg</span>
        </div>
        <div class="form-item" style="width: 230px">
          <label>成分:</label>
          <el-input v-model="formData.composition"></el-input>
        </div>
        <div class="form-item two-col-wrap">
          <div class="form-item-inline">
            <label>纱支:</label>
            <el-input v-model="formData.yarnCount"></el-input>
          </div>
          <div class="form-item-inline">
            <label>密度:</label>
            <el-input v-model="formData.density"></el-input>
          </div>
        </div>
        <div class="form-item" style="width: 230px">
          <label>规格:</label>
          <el-input v-model="formData.spec"></el-input>
        </div>
        <div class="form-item" style="width: 420px">
          <label>备注:</label>
          <el-input v-model="formData.remark"></el-input>
        </div>
      </div>
      <!-- 右侧供应商表格区域 -->
      <div class="right-table-wrap">
        <div class="table-header">
          <h2 class="table-title">面料供应商信息</h2>
          <div class="header-btns">
            <el-button class="publish-btn" size="small" @click="addSupplier"
              >添加供应商</el-button
            >
            <el-button class="publish-btn" size="small" @click="save"
              >保存</el-button
            >
          </div>
        </div>
        <el-table :data="supplierList" border style="width: 100%">
          <el-table-column prop="name" label="商家名" width="200">
            <template #default="{ row }">
              <el-input v-model="row.name"></el-input>
            </template>
          </el-table-column>
          <el-table-column
            prop="memberProductName"
            label="商家产品编号"
            width="200"
          >
            <template #default="{ row }">
              <el-input v-model="row.memberProductName"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="date" label="录入时间" max-width="200">
            <template #default="{ row }">
              <el-date-picker
                v-model="row.date"
                type="date"
                placeholder="选择日期"
                value-format="YYYY-MM-DD"
                format="YYYY-MM-DD"
                style="width: 100%; padding: 0px 40px"
                :teleport="true"
              />
            </template>
          </el-table-column>
          <el-table-column label="操作" width="100">
            <template #default="{ $index }">
              <el-button type="text" @click="delSupplier($index)">×</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script setup>
import { reactive, onMounted, onBeforeUnmount, getCurrentInstance } from "vue";
import dayjs from "dayjs";

// 获取全局实例，拿到 $api、$message
const { proxy } = getCurrentInstance();

// 表单数据
const formData = reactive({
  productNo: "",
  width: "",
  weight: "",
  quantify: "",
  composition: "",
  yarnCount: "",
  density: "",
  spec: "",
  remark: "",
});

//供应商列表
const supplierList = reactive([]);

//读取草稿
const loadDraft = () => {
  const str = sessionStorage.getItem("fabricDraft");
  if (str) {
    try {
      const draft = JSON.parse(str);
      Object.assign(formData, draft.formData);
      supplierList.length = 0;
      supplierList.push(...draft.supplierList);
    } catch (e) {
      sessionStorage.removeItem("fabricDraft");
    }
  }
};

//保存草稿
const saveDraft = () => {
  const draft = {
    formData: formData,
    supplierList: supplierList,
  };
  sessionStorage.setItem("fabricDraft", JSON.stringify(draft));
};

//清空草稿
const clearDraft = () => {
  sessionStorage.removeItem("fabricDraft");
};

//新增供应商
const addSupplier = () => {
  supplierList.push({
    name: "",
    memberProductName: "",
    date: dayjs(new Date()).format("YYYY-MM-DD"),
  });
};

//删除供应商
const delSupplier = (index) => {
  supplierList.splice(index, 1);
};

//重置表单
const del = () => {
  formData.productNo = "";
  formData.width = "";
  formData.weight = "";
  formData.quantify = "";
  formData.composition = "";
  formData.yarnCount = "";
  formData.density = "";
  formData.spec = "";
  formData.remark = "";
  supplierList.length = 0;
  clearDraft();
};

//保存提交
const save = async () => {
  if (formData.productNo == "") {
    proxy.$message.warning("品名编号不能为空");
    return;
  }
  const sendata = {
    name: formData.productNo, //品名编号
    width: formData.width == "" ? formData.width : formData.width + "cm", //幅宽
    weight: formData.weight == "" ? formData.weight : formData.weight + "g/㎡", //克重
    ingredients: formData.composition, //成份
    quantify:
      formData.quantify == "" ? formData.quantify : formData.quantify + "m/kg", //量化
    remark: formData.remark, //备注
    yarnCount: formData.yarnCount, //纱支
    density: formData.density, //密度
    specification: formData.spec, //规格
    supplierList: supplierList,
  };
  console.log(sendata, "参数");
  const res = await proxy.$api.Operation.Baseproduct.add(sendata);
  if (res.data.code == "200") {
    proxy.$message.success("新增面料信息成功");
    del();
  } else {
    proxy.$message.error("网络错误");
  }
};

//生命周期
onMounted(() => {
  loadDraft();
});

onBeforeUnmount(() => {
  saveDraft();
});
</script>

<style lang="scss" scoped>
@import "./base-product.scss";
.panel-title {
  color: #999;
}
.content-wrap {
  display: flex;
  gap: 30px;
  margin-top: 20px;
  border: 1px solid #ccc;
  padding: 24px;
}
.left-form {
  width: 400px;
  .form-item {
    display: flex;
    align-items: center;
    margin-bottom: 18px;
    label {
      width: 80px;
      flex-shrink: 0;
      font-size: 15px;
      text-align: center;
    }
    :deep(.el-input) {
      flex: 1;
    }
  }
  .two-col-wrap {
    gap: 16px;
    .form-item-inline {
      display: flex;
      align-items: center;
      flex: 1;
      label {
        width: 80px;
        flex-shrink: 0;
      }
      :deep(.el-input) {
        flex: 1;
      }
    }
  }
}
.right-table-wrap {
  flex: 1;
  .table-header {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    margin-bottom: 12px;
    .table-title {
      font-size: 22px;
      font-weight: normal;
      margin: 0;
    }
    .header-btns {
      position: absolute;
      right: 0;
      display: flex;
      gap: 8px;
    }
  }
  :deep(.el-input__inner) {
    padding: 0 8px;
  }
  //修复表格内日期选择器图标与文字重叠
  :deep(.el-date-picker) {
    width: 100%;
  }
  :deep(.el-date-picker__wrapper) {
    padding-right: 34px !important;
  }
}
.publish-btn {
  background-color: #ff9900;
}
</style>
